export default "__VITE_ASSET__CgE7uovC__"